import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-title',
  imports: [],
  templateUrl: './title.component.html'
})
export class TitleComponent {

  @Input()
  text: string
}
